import "./auth/auth.handler";
import "./session/session.switch.handler";
import "./session/session.switch_error.handler";
import "./ui/ui.freeze.handler";
import "./task/task.progress.handler";
import "./chat/chat.message.handler";
import "./campaign/campaign_form.update.handler";
import "./bumblebee/bumblebee.update.handler";
import { initMessageNotificationSound } from "../../utils/playMessageNotificationSound";

initMessageNotificationSound();
